<template>
  <div class="page p-analyze">
    <header>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          :to="{
            path: exerciseType ? '/pt/exercise-center' : '/pt/test-center',
          }"
          >{{ exerciseType ? "练习中心" : "测评中心" }}</el-breadcrumb-item
        >
        <el-breadcrumb-item>共性分析</el-breadcrumb-item>
      </el-breadcrumb>
      <card-header class="mt-20">共性分析</card-header>
      <div class="s-tabs">
        <div class="s-nav-container">
          <div
            @click="onTabClick('CommonWrong')"
            class="s-tab-nav"
            :class="activeTab === 'CommonWrong' ? 'is-active' : ''"
          >
            高频错题
          </div>
          <div
            @click="onTabClick('CommonWeak')"
            class="s-tab-nav"
            :class="activeTab === 'CommonWeak' ? 'is-active' : ''"
          >
            共性薄弱知识点
          </div>
        </div>
        <div class="hr"></div>
      </div>
    </header>
    <template v-if="activeTab === 'CommonWrong'">
      <div class="s-container">
        <div class="f-label">选择班级:</div>
        <el-col :span="5">
          <el-select v-model="searchForm.class_id" placeholder="选择班级">
            <el-option
              v-for="(c, i) in this.classList"
              :value="c.code"
              :label="c.name"
              :key="i"
            ></el-option>
          </el-select>
        </el-col>
        <el-radio v-model="radio" label="1"> 选择产生时间: </el-radio>
        <el-select v-model="selectedYear" placeholder="选择产生时间">
          <el-option
            v-for="(year, i) in yearList"
            :key="i"
            :value="year.value"
            :label="year.label"
          ></el-option>
        </el-select>
        <el-radio v-model="radio" label="2" class="ml-10">
          选择自定义时间:
          <!-- <div class="f-label ml-10">选择产生时间:</div> -->
        </el-radio>
        <el-date-picker
          popper-class="picker-ppp"
          @change="pickChange"
          v-model="dateRange"
          type="daterange"
          unlink-panels
          range-separator="至"
          :default-value="Date.now() - 29 * 24 * 3600 * 1000"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
      <div class="hr"></div>
      <div class="create-at-content">
        <div class="f-left" ref="container">
          <div class="selector-container">
            <div
              class="version-header"
              @click="showVersion = !showVersion"
              :class="showVersion ? 'is-blue' : ''"
            >
              <p
                v-if="
                  category.subjectId !== '' &&
                  category.gradeId !== '' &&
                  category.textbookId !== ''
                "
              >
                <span class="result-text">{{ category.subjectName }}</span> -
                <span class="result-text"
                  >{{ category.gradeName }}{{ category.termName }}</span
                >
                -
                <span class="result-text">
                  {{ category.versionsName || category.textbookName }}
                </span>
              </p>
              <p v-else>请选择教材版本</p>
            </div>
            <!-- 选择教材版本 -->
            <choise-category
              v-if="showVersion && exerciseType"
              type="CommonWrong"
              :classId="searchForm.class_id"
              fromType="3"
              @hideSubjectGradeText="hideSubjectGradeText"
            ></choise-category>
            <ChoiseEvaCategory
              ref="ChoiseEvaCategory"
              type="EvaCommonWrong"
              @change="onDataChange"
              :classId="searchForm.class_id"
              v-show="showVersion && !exerciseType"
              @hideSubjectGradeText="hideSubjectGradeText"
              :exerciseType="exerciseType"
            ></ChoiseEvaCategory>
          </div>
          <div class="all-mistake pointer" @click="allMistake">全部错题</div>
          <!-- 理科选择知识点 -->
          <choose-knowledgePoints
            :data="chapterList"
            :showTag="exerciseType"
            :fromType="3"
            type="CommonWrong"
            @toggle="onToggle"
            @changeCourse="onChangeCourse"
            v-if="
              category.subjectId !== '' &&
              category.gradeId !== '' &&
              category.textbookId !== '' &&
              scienceArr.includes(Number(this.category.subjectId))
            "
          ></choose-knowledgePoints>
          <!-- 文科选择课时 -->
          <choose-tagCode
            :data="chapterList"
            @toggle="onToggle"
            @toggleTag="onToggleTag"
            type="CommonWrong"
            v-else
          ></choose-tagCode>
        </div>
        <div class="f-main">
          <HighFiltrate
            :knowledgeName="knowledgeName"
            :type="false"
            @clearPage="clearPage"
            isWong
          ></HighFiltrate>
          <div class="f-s-b" style="margin-left: 28px" v-if="totalCount">
            <div class="meta-info f-s-b">
              <span
                >共<b>{{ totalCount }}</b
                >道题目</span
              >
              <span @click="onSortClick('total')" class="f-s-b"
                >答题次数
                <b class="cart-wrapper" :class="getStyle('total')">
                  <i class="el-icon-caret-top" style="margin-bottom: -8px"></i>
                  <i class="el-icon-caret-bottom"></i>
                </b>
              </span>
              <span @click="onSortClick('right_rate')" class="f-s-b"
                >正答率
                <b class="cart-wrapper" :class="getStyle('right_rate')">
                  <i class="el-icon-caret-top" style="margin-bottom: -8px"></i>
                  <i class="el-icon-caret-bottom"></i>
                </b>
              </span>
            </div>
            <button
              v-if="
                scienceArr.includes(Number(this.category.subjectId)) &&
                exerciseType
              "
              class="btn-check"
              @click="onCheckAllClick"
            ></button>
          </div>
          <high-question-content
            :searchForm="searchForm"
            classId="classId"
            :formedTargets="formedTargets"
            :questionList="questionList"
            :type="scienceArr.includes(Number(this.category.subjectId))"
            :subjectId="Number(this.category.subjectId)"
            @submitAnalysis="submitAnalysis"
            @videoOpen="videoOpen"
            :exerciseType="exerciseType"
            :subject-id="category.subjectId"
            :totalCount="totalCount"
          />
          <!-- 分页 -->
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            :page-size="pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </template>
    <!-- show="activeTab ==='CommonWeak'" -->
    <!-- <CommonWeak :exerciseType="exerciseType" v-else /> -->
    <CommonWeak
      :exerciseType="exerciseType"
      v-show="activeTab === 'CommonWeak'"
    />
    <!-- 试题篮 -->
    <div
      class="basket pointer"
      @click="goQuestionBasket"
      v-show="questionsBasket && questionsBasket.length > 0"
    >
      <p class="basket-content">试题篮</p>
      <p class="basket-number">{{ questionsBasket.length }}/50</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import { CACHED_CLASS_WRONG, CRM_USER } from '@/config/storage';
import {
  getCmsCourseTree, getQuestionPackageList, getTeacherClass,
  getClassCommonWrongQuestionList, evaluateClassCommonWrongQuestionList,
  getClassSubjectList, getClassSGVList,
} from '@/api/pt';
import CardHeader from '@/components/card-header.vue';
import ChoiseCategory from './components/choose-category.vue';
import ChooseKnowledgePoints from './components/choose-knowledgePoints.vue';
import ChooseTagCode from './components/choose-tagCode.vue';
import HighQuestionContent from './components/high-question-content.vue';
import HighFiltrate from './components/high-filtrate.vue';
import CommonWeak from './exercise-common-weak.vue';
import ChoiseEvaCategory from './components/choose-eva-category.vue';
import { isScienceArr } from '@/utils';

export default {
  name: 'ExerciseAnalyze',
  components: {
    CardHeader,
    ChoiseCategory,
    ChooseKnowledgePoints,
    ChooseTagCode,
    HighQuestionContent,
    HighFiltrate,
    CommonWeak,
    ChoiseEvaCategory,
  },
  data() {
    const userInfo = JSON.parse(localStorage.getItem(CRM_USER)) || {};
    // const { activeTab } = this.$route.query;
    return {
      questionType: '',
      difficultyLevel: '',
      radio: '1', // 时间单选框
      totalCount: 0,
      exerciseType: this.$route.path.includes('exercise-type'),
      searchForm: {
        class_id: '', // 当前班级id
        startDate: '', // 开始时间
        endDate: '', // 结束时间
      },
      formedTargets: {}, // 当前年级信息
      sort: '',
      order: '',
      scienceArr: [2, 4, 5],
      showVersion: false,
      userInfo,
      chapterList: [],
      subjectId: '',
      gradeId: '',
      termId: '',
      textbookId: '',
      questionList: [],
      currentKnowledgeCode: '',
      knowledgeName: '',
      packInfoList: [],
      activeTab: 'CommonWrong', // 进入的页面由路由中携带的来判断
      selectedClass: '',
      classList: [],
      dateRange: [Date.now() - 30 * 24 * 3600 * 1000, Date.now()],
      selectedYear: 2021,
      pickerMinDate: '',
      yearList: [{
        // 后端让写死的
        value: 2021,
        label: '2021学年',
      }],
      pickerOptions: {
        shortcuts: [{
          text: '最近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit('pick', [start, end]);
          },
        },
        {
          text: '最近14天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 13);
            picker.$emit('pick', [start, end]);
          },
        },
        {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
            picker.$emit('pick', [start, end]);
          },
        }],
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime();
          if (maxDate) {
            this.pickerMinDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate !== '') {
            const day30 = (30 - 1) * 24 * 3600 * 1000;
            let maxTime = this.pickerMinDate + day30;
            if (maxTime > new Date()) {
              maxTime = new Date();
              return time.getTime() > maxTime || time.getTime() < this.pickerMinDate - day30;
            }
            return maxTime < time.getTime() || time.getTime() < this.pickerMinDate - day30;
          }
          return time.getTime() > Date.now();
        },

      },
      currentPage: 1,
      pageSize: 10,
      currentSubject: {},
      currentGrade: {},
      currentTextBook: {},
      classId: '',
    };
  },
  computed: {
    ...mapGetters([
      'commonWrongCategoryObj',
      'questionsBasket',
      'courseInformation',
      'evaWrongCategoryObj',
    ]),
    category() {
      if (!this.exerciseType) {
        return this.evaWrongCategoryObj;
      }
      return this.commonWrongCategoryObj;
    },
  },
  watch: {
    'searchForm.class_id': {
      handler(newV, oldV) {
        this.pageSize = 10;
        this.currentPage = 1;
        if (newV !== oldV) {
          localStorage.setItem(CACHED_CLASS_WRONG, JSON.stringify(newV));
          if (this.exerciseType) {
            this.getCmsSubjectList();
          }
          if (!this.exerciseType) {
            this.$nextTick(() => {
              this.$refs.ChoiseEvaCategory.getAccurateCategory('subjects', newV);
            });
          }
          this.showVersion = false;
        }
      },
      // immediate: true,
    },
    radio: function changeRadio(newV) {
      this.pageSize = 10;
      this.currentPage = 1;
      if (newV === '2') {
        this.pickChange();
      } else {
        this.$nextTick(this.queryClassCommonWrongQuestionList());
      }
    },
  },
  methods: {
    // 文科知识点点击操作
    onToggleTag(packItem, tagItem) {
      console.log('packItem---------------', packItem, tagItem);
      const topicId = packItem.topic_id;
      const kModule = packItem.k_module;
      const kModuleName = packItem.k_module_name;
      this.knowledgeName = packItem.tag_name;
      this.currentPackageId = packItem.id;
      this.currentKnowledgeCode = (tagItem && tagItem.tag_code)
        || packItem.tag_code
        || this.getPackCodes(packItem.list);
      console.log(topicId, kModule, kModuleName, this.currentPackageId);
      this.queryClassCommonWrongQuestionList();
      this.$store.commit('SELECT_TAG_ARRAY', packItem.list);
    },
    getStyle(order) {
      if (order !== this.order) {
        return '';
      }
      return this.sort;
    },
    onSortClick(val) {
      // asc desc
      this.order = val;
      this.sort = this.sort === 'asc' ? 'desc' : 'asc';
      this.queryClassCommonWrongQuestionList();
    },
    onCheckAllClick() {
      this.questionList.forEach(this.putInBasket);
    },
    includesThisQuestion(q) {
      const { questionsBasket } = this.$store.state;
      const str = questionsBasket.some((item) => item.question_uuid === q.question_uuid);
      if (str) {
        return true;
      }
      return false;
    },
    putInBasket(question) {
      if (!this.includesThisQuestion(question)) {
        console.log('没有这道题-----------');
        this.$set(question, 'active', false);
        this.$store.commit('PUTIN_QUESTIONS_BASKET', question);
      }
    },
    onChangeCourse(item) {
      this.pageSize = 10;
      this.currentPage = 1;
      const courseInfo = {
        courseId: item.course_id || item.test_id,
        courseName: item.course_name || item.test_name,
        lessonId: item.lesson_id,
      };
      this.$store.commit('CHANGE_COURSE_INFORMATION', courseInfo);
      this.queryClassCommonWrongQuestionList();
    },
    onDataChange(data) {
      this.pageSize = 10;
      this.currentPage = 1;
      this.showVersion = false;
      this.chapterList = data;
      this.queryClassCommonWrongQuestionList(true);
    },
    handleSizeChange(v) {
      this.pageSize = v;
      if (this.currentPage === 1) {
        this.queryClassCommonWrongQuestionList();
      } else {
        this.handleCurrentChange(1);
      }
    },
    handleCurrentChange(v) {
      this.currentPage = v;
      this.queryClassCommonWrongQuestionList();
    },
    // 获取布置年级
    async getTeacherClassYear() {
      const res = await getTeacherClass({ id: '' });
      if (res.code === 200) {
        this.classList = res.data;
        const cachedClass = JSON.parse(localStorage.getItem(CACHED_CLASS_WRONG) || null);
        if (cachedClass) {
          this.searchForm.class_id = cachedClass;
        } else {
          this.searchForm.class_id = this.classList[0].code;
        }
      }
    },
    pickChange() {
      this.pageSize = 10;
      this.currentPage = 1;
      if (this.dateRange) {
        const startDate = dayjs(this.dateRange[0]).format('YYYY-MM-DD');
        const endDate = dayjs(this.dateRange[1]).format('YYYY-MM-DD');
        this.searchForm.startDate = startDate;
        this.searchForm.endDate = endDate;
      } else {
        this.searchForm.startDate = '';
        this.searchForm.endDate = '';
      }
      if (this.radio === '2') {
        this.queryClassCommonWrongQuestionList();
      }
    },
    onTabClick(name) {
      this.activeTab = name;
    },
    // 重新选择版本操作
    hideSubjectGradeText(isNeedQuery) {
      this.showVersion = false;
      this.knowledgeName = '';
      if (isNeedQuery && this.exerciseType) {
        this.queryCourseTree();
      }
    },
    // 查询当前版本章节列表
    queryCourseTree() {
      this.chapterList = [];
      this.questionList = [];
      this.subjectId = this.category.subjectId;
      this.gradeId = this.category.gradeId;
      this.textbookId = this.category.textbookId;
      this.termId = this.category.termId;
      const params = {
        subject_id: this.subjectId,
        grade_id: this.gradeId,
        textbook_id: this.textbookId,
        extend_info: 1,
        term_id: this.termId,
        hw_type: 3,
      };
      getCmsCourseTree(params).then((res) => {
        if (res.code === 200) {
          const chapterArr = res.data;
          this.currentKnowledgeCode = '';
          chapterArr.forEach((item, index) => {
            if (index === 0 && this.exerciseType) {
              this.getQuestionPackageList(item);
              this.chapterList.push({
                course_id: item.course_id,
                lesson_id: item.lesson_id,
                lesson_name: item.lesson_name,
                module_id: item.module_id,
                module_name: item.module_name,
                packInfo: this.packInfoList,
                active: true,
              });
            } else {
              this.chapterList.push({
                course_id: item.course_id,
                lesson_id: item.lesson_id,
                lesson_name: item.lesson_name,
                module_id: item.module_id,
                module_name: item.module_name,
                active: false,
              });
            }
          });
        }
      });
    },
    // 根据课次获取对应的知识点列表
    async getQuestionPackageList(item) {
      this.packInfoList = [];
      const courseInfo = {
        courseId: item.course_id,
        courseName: item.course_name,
        lessonId: item.lesson_id,
      };
      this.$store.commit('CHANGE_COURSE_INFORMATION', courseInfo);
      const params = {
        subject_id: this.category.subjectId,
        hw_type: 3,
        module_id: item.module_id,
      };
      await getQuestionPackageList(params).then((res) => {
        if (res.code === 200) {
          const knowledgeArr = res.data;
          if (knowledgeArr.length > 0) {
            // 文理科知识点数据结构不一样,理科
            if (isScienceArr(this.commonWrongCategoryObj.subjectId)) {
              knowledgeArr.forEach((knowledge) => {
                this.packInfoList.push({
                  tag_code: knowledge.tag_code,
                  tag_name: knowledge.tag_name,
                  active: false,
                  type: '理科',
                });
              });
            } else {
              knowledgeArr.forEach((knowledge) => {
                knowledge.list.forEach((tag) => {
                  this.$set(tag, 'active', false);
                });
                this.packInfoList.push({
                  topic_id: params.module_id,
                  id: knowledge.id,
                  question_pack_id: knowledge.id,
                  tag_name: knowledge.name,
                  k_module: knowledge.k_module,
                  k_module_name: knowledge.k_module_name,
                  list: knowledge.list,
                  rand_id: knowledge.rand_id,
                  sort: knowledge.sort,
                  active: false,
                  type: '文科',
                  question_list: [],
                  question_info_list: [],
                });
              });
              // 默认展开第一个
              // this.onToggleTag(this.packInfoList[0]);
              this.$store.commit('SET_TOPIC_LIST', this.packInfoList);
            }
          }
        }
      });
      this.queryClassCommonWrongQuestionList();
    },
    // 筛选是重置page
    clearPage(value, code) {
      if (value === 'questionType') { // 题型
        this.questionType = code;
      } else if (value === 'difficultyLevel') { // 难度
        this.difficultyLevel = code;
      } else { // 知识点
        this.currentKnowledgeCode = code;
      }
      this.currentPage = 1;
      this.pageSize = 10;
      console.log('clear page', this.questionType, this.difficultyLevel);
      this.queryClassCommonWrongQuestionList(true);
    },
    isValid(data, ...keys) {
      return keys.every((key) => !this.isVoid(data[key]));
    },
    isVoid(val) {
      return val === null || val === '' || val === undefined;
    },
    // 获取试题列表
    queryClassCommonWrongQuestionList(all) {
      const SchoolClassId = this.classList.filter(
        (item) => item.id === this.searchForm.class_id,
      )[0].school_master_class_id;
      this.questionList = [];
      const params = {
        class_id: this.searchForm.class_id,
        school_master_class_id: SchoolClassId || '',
        subject_id: this.category.subjectId || 2,
        test_id: all ? '' : this.courseInformation.courseId,
        course_id: this.courseInformation.courseId,
        lesson_id: '',
        tag_codes: this.currentKnowledgeCode,
        q_type: this.questionType,
        difficulty: this.difficultyLevel,
        start_time: this.radio !== '1' ? this.searchForm.startDate : '',
        end_time: this.radio !== '1' ? this.searchForm.endDate : '',
        grade_year: this.radio === '1' ? this.selectedYear : '',
        order: this.order || '',
        sort: this.sort || '',
        page: this.currentPage,
        page_size: this.pageSize,
      };
      if (!this.isValid(params, 'class_id', 'subject_id')) {
        console.log({ params });
        return;
      }
      if (this.exerciseType) {
        getClassCommonWrongQuestionList(params).then((res) => {
          if (res.code === 200) {
            this.questionList = res.data.items || [];
            this.totalCount = res.data.total;
            this.questionList.forEach((item, index) => {
              this.$set(item, 'active', false);
              this.$set(item, 'num', ((this.currentPage - 1) * 10 + (index + 1)));
            });
          } else {
            this.$message({
              type: 'warning',
              message: '请重新筛选',
            });
          }
        });
      } else {
        evaluateClassCommonWrongQuestionList(params).then((res) => {
          if (res.code === 200) {
            this.questionList = res.data.items || [];
            this.totalCount = res.data.total;
            this.questionList.forEach((item, index) => {
              this.$set(item, 'active', false);
              this.$set(item, 'num', ((this.currentPage - 1) * 10 + (index + 1)));
            });
          } else {
            this.$message({
              type: 'warning',
              message: '请重新筛选',
            });
          }
        });
      }
    },
    // 知识点点击操作
    onToggle(item) {
      this.currentKnowledgeCode = item.tag_code;
      this.knowledgeName = item.tag_name;
      this.currentPage = 1;
      this.pageSize = 10;
      this.queryClassCommonWrongQuestionList();
    },
    // 反馈
    submitAnalysis(uuid) {
      this.questionUUid = uuid;
      this.centerDialogVisible = true;
    },
    // 视频播放
    videoOpen(val) {
      this.dialogVisible = true;
      this.videoUrl = val;
    },
    // 去试题篮
    goQuestionBasket() {
      this.$router.push({
        path: '/pt/question-basket',
        query: {
          fromType: 'classCommonWrong',
        },
      });
    },
    // 首次获取学科
    async getCmsSubjectList() {
      const res = await getClassSubjectList({
        hw_type: 3,
        class_id: this.searchForm.class_id,
      });
      if (res.code === 200) {
        const arr = res.data[0];
        this.currentSubject = arr;
      }
      this.querySGVList();
    },
    // 首次获取版本信息
    async querySGVList() {
      await getClassSGVList({
        subject_id: this.currentSubject.subject_id,
        hw_type: 3,
        class_id: this.searchForm.class_id,
      }).then((res) => {
        if (res.code === 200) {
          const { grade } = res.data;
          const gradeArr = grade[0];
          const textArr = grade[0].textbook[0];
          this.currentGrade = gradeArr;
          this.currentTextBook = textArr;
        }
      });
      const category = JSON.parse(localStorage.getItem(`category-last_${this.searchForm.class_id}`)) || {};
      const cateGoryObj = {
        subjectId: this.currentSubject.subject_id,
        subjectName: this.currentSubject.subject_name,
        gradeId: this.currentGrade.grade_id,
        gradeName: this.currentGrade.grade_name,
        termId: this.currentGrade.term_id,
        termName: this.currentGrade.term_name,
        textbookId: this.currentTextBook.textbook_id,
        textbookName: this.currentTextBook.textbook_name,
      };
      if (category.subjectId !== undefined) {
        this.$store.commit('SET_COMMON_WRONG_CATEGORY_OBJ', category);
      } else {
        this.$store.commit('SET_COMMON_WRONG_CATEGORY_OBJ', cateGoryObj);
      }
      this.queryCourseTree();
    },
    // 全部错题点击操作
    allMistake() {
      console.log('全部错题--------------');
      this.pageSize = 10;
      this.currentPage = 1;
      this.knowledgeName = '';
      this.currentKnowledgeCode = '';
      this.chapterList.forEach((chapter) => {
        this.$set(chapter, 'active', false);
        if (chapter.packInfo) {
          chapter.packInfo.forEach((lesson) => {
            this.$set(lesson, 'active', false);
          });
        }
      });
      this.queryClassCommonWrongQuestionList(true);
    },
  },
  activated() {
    // 缓存处理
    if (!this.$route.meta.isUseCache && !this.exerciseType) {
      console.log('不使用缓存----------------');
      this.questionList = [];
      if (this.category.subjectId !== '' && this.category.gradeId !== '' && this.category.textbookId !== '') {
        this.queryCourseTree();
      }
    } else {
      this.$route.meta.isUseCache = false;
    }
  },
  async created() {
    if (this.$route.query && this.$route.query.activeTab) {
      this.activeTab = this.$route.query.activeTab;
    }
    await this.getTeacherClassYear();
  },
};
</script>

<style lang="scss" scoped>
.p-analyze {
  .create-at-content {
    display: flex;
  }
  .meta-info {
    color: rgba(17, 31, 44, 0.56);
    span {
      margin-right: 28px;
    }
    b {
      font-weight: normal;
      color: rgba(25, 137, 250, 1);
    }
    .cart-wrapper {
      display: flex;
      flex-direction: column;
      color: rgba(192, 196, 204, 1);
      &.asc {
        .el-icon-caret-top {
          color: rgba(144, 147, 153, 1);
        }
      }
      &.desc {
        .el-icon-caret-bottom {
          color: rgba(144, 147, 153, 1);
        }
      }
    }
  }
  .f-left {
    width: 256px;
    box-shadow: 2px 0px 8px 0px rgba(220, 225, 236, 0.5);
    padding-top: 6px;
    min-height: 780px;
    z-index: 2;
    .all-mistake {
      margin-left: 19px;
      margin-left: 16px;
      // border: 1px solid red;
      width: 132px;
      height: 21px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1989fa;
      line-height: 21px;
    }
  }
  .f-main {
    flex: 1;
    position: relative;
    /deep/ .el-pagination {
      display: flex;
      position: absolute;
      padding-top: 20px;
      // width: calc(100% - 64px);
      bottom: -40px;
      left: 30px;
      .btn-prev {
        margin-left: auto;
      }
    }
  }
  .btn-check {
    width: 1.34rem;
    height: 0.4rem;
    background-image: url("~@/views/pt/images/check_all.png");
    background-size: 100% 100%;
  }
  .s-container {
    display: flex;
    align-items: center;
    padding: 17px;
    .f-label {
      color: #000;
      font-size: 15px;
      margin-right: 10px;
    }
    /deep/ .el-radio {
      margin-right: 10px;
      .el-radio__label {
        padding: 0px;
        color: #000;
        font-size: 15px;
      }
    }
  }
  .selector-container {
    margin-bottom: 24px;
    .version-header {
      width: 240px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #c4c8d2;
      line-height: 40px;
      font-size: 14px;
      padding: 0 15px;
      box-sizing: border-box;
      overflow: hidden;
    }
    .is-blue {
      border: 1px solid #1989fa;
    }
  }
  .c-subtile {
    color: rgba(48, 49, 51, 0.6);
    font-size: 14px;
    margin-top: 40px;
    padding-bottom: 20px;
  }
  .basket {
    position: fixed;
    top: 160px;
    right: 0px;
    width: 56px;
    height: 170px;
    background: #1989fa;
    box-shadow: 0px 2px 6px 0px rgba(129, 172, 223, 0.51);
    border-radius: 8px;
    .basket-content {
      padding-top: 30px;
      text-align: center;
      margin: 10px auto;
      width: 26px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      background: url("../images/question_basket.png") no-repeat;
      background-size: 26px 24px;
    }
    .basket-number {
      margin: 16px auto;
      width: 38px;
      height: 38px;
      background: #81acdf;
      border-radius: 50%;
      line-height: 38px;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>
